import React from 'react';
import { Box, Container, Typography, Link, Grid } from '@mui/material';
import { FaFacebook, FaInstagram, FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import { SiTiktok } from 'react-icons/si';
// Logo PNG simple demandé
import logoEcotij from '../logo.png';

const Footer = () => {
  return (
    <Box 
      component="footer" 
      sx={{ 
        background: '#ffffff',
        color: '#1e293b', 
        pt: { xs: 8, md: 10 }, 
        pb: { xs: 6, md: 5 }, // Augmente padding bottom sur mobile
        mt: 'auto',
        position: 'relative',
        overflow: 'hidden',
        borderTop: '3px solid',
        borderImage: 'linear-gradient(90deg, transparent 0%, #0077B8 30%, #00ACEA 50%, #F5A000 70%, transparent 100%) 1',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: `
            radial-gradient(circle at 20% 30%, rgba(0, 119, 184, 0.03) 0%, transparent 50%),
            radial-gradient(circle at 80% 70%, rgba(0, 172, 234, 0.03) 0%, transparent 50%)
          `,
          pointerEvents: 'none',
        }
      }}
    >
      <Container maxWidth="xl" sx={{ position: 'relative', zIndex: 1 }}>
        <Grid
          container
          spacing={{ xs: 4, md: 5 }}
          alignItems="flex-start"
          justifyContent={{ md: 'space-between' }}
        >
          {/* Brand Section (left) */}
          <Grid item xs={12} md={4} sx={{ pl: { md: 2 } }}>
            <Box sx={{ mb: 3 }}>
              <Box 
                component="img" 
                src={logoEcotij} 
                alt="ECOTIJ" 
                sx={{ 
                  width: { xs: 200, md: 240 }, 
                  height: 'auto',
                  maxHeight: 85,
                  objectFit: 'contain',
                  display: 'block',
                  filter: 'drop-shadow(0 2px 8px rgba(0,0,0,0.08))'
                }} 
              />
            </Box>
            <Typography 
              sx={{ 
                color: '#475569',
                fontSize: '0.9rem',
                lineHeight: 1.6,
                fontWeight: 500,
                mb: 3,
                maxWidth: 520,
              }}
            >
              Équipements auto & poids lourds: 
              éclairage, câblage et connectique.
            </Typography>
            
          </Grid>

          {/* Middle content: Navigation + Socials */}
          <Grid item xs={12} md={5}>
            <Grid container spacing={{ xs: 4, md: 5 }}>
              {/* Navigation (middle-left) */}
              <Grid item xs={12} sm={6}>
                <Typography 
                  variant="h6" 
                  fontWeight={800} 
                  gutterBottom
                  sx={{ 
                    fontSize: '1.063rem',
                    mb: 2.5,
                    textAlign: { xs: 'left', sm: 'left' },
                    display: 'block',
                    '&::before': { content: 'none' },
                    '&::after': { content: 'none' },
                  }}
                >
                  Navigation
                </Typography>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                  {[
                    { label: 'Accueil', href: '/' },
                    { label: 'Catalogue', href: '/catalogue' },
                    { label: 'Contact', href: '/contact' },
                  ].map((link) => (
                    <Link 
                      key={link.href}
                      href={link.href} 
                      color="inherit" 
                      underline="none"
                      sx={{ 
                        fontSize: '0.938rem',
                        color: '#475569',
                        transition: 'all 0.2s ease',
                        display: 'inline-block',
                        cursor: 'pointer',
                        '&:hover': { 
                          color: '#0077B8',
                          transform: 'translateX(4px)'
                        },
                      }}
                    >
                      {link.label}
                    </Link>
                  ))}
                </Box>
              </Grid>

              {/* Suivez-nous (middle-right) */}
              <Grid item xs={12} sm={6}>
                <Typography 
                  variant="h6" 
                  fontWeight={800} 
                  gutterBottom
                  sx={{ 
                    fontSize: '1.063rem',
                    mb: 2.5,
                    textAlign: { xs: 'left', sm: 'left' },
                  }}
                >
                  Suivez-nous
                </Typography>
                <Box sx={{ display: 'flex', gap: 1.5 }}>
                  <Link href="https://www.instagram.com/ecotij_shop?utm_source=qr&igsh=MXEycXNvMzZpNXplNA==" target="_blank" rel="noopener noreferrer" underline="none">
                    <Box aria-label="Instagram" sx={{ width: 40, height: 40, borderRadius: '50%', bgcolor: '#E1306C', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 6px 16px rgba(225,48,108,0.35)', transition: 'transform .2s ease', '&:hover': { transform: 'translateY(-2px)' } }}>
                      <FaInstagram size={18} />
                    </Box>
                  </Link>
                  <Link href="https://www.tiktok.com/@ecotij22?_r=1&_t=ZN-91oS5SL8hN8" target="_blank" rel="noopener noreferrer" underline="none">
                    <Box aria-label="TikTok" sx={{ width: 40, height: 40, borderRadius: '50%', bgcolor: '#000000', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 6px 16px rgba(0,0,0,0.35)', transition: 'transform .2s ease', '&:hover': { transform: 'translateY(-2px)' } }}>
                      <SiTiktok size={18} />
                    </Box>
                  </Link>
                  <Link href="https://www.facebook.com/ecotij" target="_blank" rel="noopener noreferrer" underline="none">
                    <Box aria-label="Facebook" sx={{ width: 40, height: 40, borderRadius: '50%', bgcolor: '#1877F2', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 6px 16px rgba(24,119,242,0.35)', transition: 'transform .2s ease', '&:hover': { transform: 'translateY(-2px)' } }}>
                      <FaFacebook size={18} />
                    </Box>
                  </Link>
                </Box>
              </Grid>
            </Grid>
          </Grid>

          {/* Contact Info (right) */}
          <Grid item xs={12} sm={6} md={3} sx={{ pr: { md: 2 } }}>
            <Typography 
              variant="h6" 
              fontWeight={800} 
              gutterBottom
              sx={{ 
                fontSize: '1.063rem',
                mb: 2.5,
              }}
            >
              Contactez-nous
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mb: 3 }}>
              <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
                <Box sx={{ color: '#F5A000', mt: 0.5 }}>
                  <FaPhone size={16} />
                </Box>
                <Box>
                  <Typography sx={{ fontSize: '0.813rem', color: '#64748b', mb: 0.25, fontWeight: 600 }}>
                    Téléphone
                  </Typography>
                  <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    <Typography sx={{ fontSize: '0.938rem', fontWeight: 600, color: '#1e293b' }}>
                      06 61 83 77 26
                    </Typography>
                    <Typography sx={{ fontSize: '0.938rem', fontWeight: 600, color: '#1e293b' }}>
                      06 65 04 92 99
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
                <Box sx={{ color: '#F5A000', mt: 0.5 }}>
                  <FaEnvelope size={16} />
                </Box>
                <Box>
                  <Typography sx={{ fontSize: '0.813rem', color: '#64748b', mb: 0.25, fontWeight: 600 }}>
                    Email
                  </Typography>
                  <Typography sx={{ fontSize: '0.938rem', fontWeight: 600, color: '#1e293b' }}>
                    contact@ecotij.ma
                  </Typography>
                </Box>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
                <Box sx={{ color: '#F5A000', mt: 0.5 }}>
                  <FaMapMarkerAlt size={16} />
                </Box>
                <Box>
                  <Typography sx={{ fontSize: '0.813rem', color: '#64748b', mb: 0.25, fontWeight: 600 }}>
                    Horaires
                  </Typography>
                  <Typography sx={{ fontSize: '0.938rem', fontWeight: 600, color: '#1e293b' }}>
                    Lun–Ven: 8h30–13h00 / 14h–18h30
                  </Typography>
                  <Typography sx={{ fontSize: '0.938rem', fontWeight: 600, color: '#1e293b' }}>
                    Samedi: 8h30–13h00
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>

        {/* Bottom Bar */}
        <Box 
          sx={{ 
            mt: { xs: 4, md: 6 },
            pt: { xs: 3, md: 4 },
            pb: { xs: 10, md: 0 }, // Padding bottom pour mobile (éviter conflit avec bouton chatbot)
            borderTop: '1px solid rgba(0, 119, 184, 0.1)',
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            justifyContent: 'flex-start',
            alignItems: 'center',
            gap: 2,
          }}
        >
          <Typography 
            variant="body2" 
            sx={{ 
              color: '#64748b',
              fontSize: '0.875rem',
              textAlign: { xs: 'center', sm: 'left' },
            }}
          >
            © {new Date().getFullYear()} Ecotij. Développé par CodeLi. Tous droits réservés.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
